<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['sell_medicine']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ ((currentPage - 1) * perPage) + data.index + 1 }}
                </template>
                <template #cell(product)="data">
                  {{ data.item.product }}
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit }}
                </template>
                <template #cell(amountpaid)="data">
                  <span class="amount-cell">UGX {{ commas(data.item.amountpaid) }}</span>
                </template>
                <template #cell(quantity)="data">
                  <span class="quantity-cell">{{ commas(data.item.quantity) }}</span>
                </template>
                <template #cell(price_type)="data">
                  <span :class="['price-type-pill', data.item.price_type === 'wholesale' ? 'wholesale' : 'retail']">
                    <span class="price-type-dot"></span>
                    <span>{{ data.item.price_type === "wholesale" ? "Wholesale" : "Retail" }}</span>
                  </span>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="TotalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>     
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Stock Levels</span></center>
          </div>
        </div>
      </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  
  export default {
    page: {
      title: "Stock Levels",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Medicine Sales Details",
        items: [ {text: "Dashboard",to: "/",}, {text: "Medicine Sales Details",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: "",
        isBusy: true,
        searchDebounce: null,
        sellproductdetails: [],
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'product', label: 'Product', visible: true },
            { key: 'unit', label: 'Unit', visible: true },
            { key: 'quantity', label: 'Quantity', visible: true },
            { key: 'price_type', label: 'Sale Type', visible: true },
            {key: 'amountpaid',label:'Amount paid', visible: true},
            { key: 'addedby', label: 'Sold by', visible: true},
            { key: 'addedon', label: 'Added on', visible: false },
          ],
        id:'',
        name:'',
      };
    },
    computed: {
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.sellproductdetails.map((d) => ({...d }))},
      IsBusy() { return this.isBusy; },
    },
    mounted() {
      this.fetchSellProductDetails();
    },
    beforeDestroy() {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
    },
    watch: {
      currentPage() {
        this.fetchSellProductDetails();
      },
      perPage() {
        this.currentPage = 1;
        this.fetchSellProductDetails();
      },
      filter() {
        this.currentPage = 1;
        if (this.searchDebounce) {
          clearTimeout(this.searchDebounce);
        }
        this.searchDebounce = setTimeout(() => {
          this.fetchSellProductDetails();
        }, 300);
      },
    },
    methods: {
      async fetchSellProductDetails() {
        this.isBusy = true;
        try {
          const response = await axios.get("/orders", {
            params: {
              page: this.currentPage,
              per_page: this.perPage,
              search: this.filter || "",
            },
          });
          this.sellproductdetails = response.data.orders || [];
          this.TotalRows = response.data.pagination?.total || 0;
        } finally {
          this.isBusy = false;
        }
      },
      commas(value) {
        return Number(value || 0).toLocaleString();
      },
    },
  };
  </script>

<style scoped>
.amount-cell {
  font-weight: 700;
  color: #0f766e;
}

.quantity-cell {
  font-weight: 600;
  color: #1f2937;
}

.price-type-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.18rem 0.65rem 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1.2;
  border: 1px solid transparent;
  background: transparent;
}

.price-type-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  flex: 0 0 7px;
}

.price-type-pill.retail {
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
}
.price-type-pill.retail .price-type-dot {
  background: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);
}

.price-type-pill.wholesale {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}
.price-type-pill.wholesale .price-type-dot {
  background: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

</style>
